import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapState('waitlist', ['waitlists']),
    ...mapState('refillCart', ['refillCart']),
    ...mapState('customer', ['cdata']),
    ...mapState('xsell', [
      'boostRecommendations',
      'showBoostOptions',
      'selectedBoost',
    ]),

    ...mapGetters('waitlist', ['isOnWaitlist']),
    ...mapGetters('subscriptions', ['nextSubShipment']),
    ...mapGetters('refillCart', ['productIdInRefillCart']),

    showOptions() {
      return !this.selectedBoostInNextShipment && this.selectedBoost.inventory_status === 'active';
    },

    selectedBoostIndex() {
      return this.boostRecommendations.findIndex(boost => boost.id == this.selectedBoost.id);
    },

    onBoostWaitlist() {
      return this.isOnWaitlist('product_waitlist', this.selectedBoost.id);
    },

    boostRecommendationLabels() {
      return this.boostRecommendations.map(rec => rec.navTitle);
    },

    selectedBoostInNextShipment() {
      return this.productIdInRefillCart(this.selectedBoost.id);
    },
  },

  methods: {
    ...mapActions('waitlist', [
      'initWaitlists',
      'addToWaitlist',
    ]),

    ...mapActions('xsell', [
      'initBoostRecommendations',
    ]),

    ...mapMutations('xsell', [
      'setShowBoostOptions',
      'setSelectedBoost',
    ]),

    updateSelectedBoost(index) {
      this.setSelectedBoost(this.boostRecommendations[index]);
    },

    openShipmentOptions() {
      this.setShowBoostOptions(true);
    },

    addBoostToWaitlist() {
      if (!this.onBoostWaitlist) {
        this.addToWaitlist({
          email: this.cdata.user.email,
          waitlist_type: 'product_waitlist',
          product_id: this.selectedBoost.id,
        });
      }
    },
  },

  mounted() {
    this.initWaitlists();
    this.initBoostRecommendations();
  },
};
